export const pushEcommerce = (data) => {
  try {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push(data);
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerAddToCart = (gtmEcommerceItems) => {
  try {
    pushEcommerce({
      event: 'gtm_add_to_cart',
      ecommerce: {
        items: gtmEcommerceItems,
        currency: gtmEcommerceItems[0].currency,
        value: gtmEcommerceItems.reduce((p, v) => p + v.price * v.quantity, 0),
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerGtmViewCart = (cart) => {
  try {
    pushEcommerce({
      event: 'gtm_view_cart',
      ecommerce: {
        currency: cart.currency,
        value: cart.gtmGrandTotal,
        items: cart.orderRows.map((r) => r.gtmEcommerceItem),
      },
    });
  } catch (e) {
    console.log(e);
  }
};
